export default "__VITE_ASSET__Bf12wvKw__"